import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-register-step-four-go',
  templateUrl: './register-step-four-go.component.html',
  styleUrls: ['./register-step-four-go.component.css']
})
export class RegisterStepFourGoComponent implements OnInit {
  userMessage ="Your account creation has succeeded"
  constructor(private userService:UserService) { }

  ngOnInit(): void {
    this.userService.userMessage.subscribe(
      x=>{
        this.userMessage=x
      }
    )
  }

}
